import merge from 'lodash/merge';
import { productOption } from './default';

const newProductOption = (obj = {}) => {
  return merge(
    {},
    productOption,
    {
      uniqueSubscriptionId: Math.random().toString(36).substring(2),
    },
    obj
  );
};

const informationFields = [
  {
    name: 'regUrl',
    text: 'Zur Registrierung',
    descriptionText:
      'Um Ihr SmartHome nutzen zu können, ist ein Benutzerkonto erforderlich. Falls Sie noch keines angelegt haben, klicken Sie auf "Zur Registrierung".',
    kind: null,
    url: '-',
    resourcePath: null,
    // isImportant: null,
  },
  {
    name: null,
    text: '',
    descriptionText:
      'Falls Sie bereits ein Benutzerkonto besitzen, loggen Sie sich in die Magenta SmartHome App ein und aktivieren Sie Ihre Lizenz mit obenstehendem Aktivierungscode.',
    kind: null,
    url: '',
    resourcePath: null,
    isImportant: true,
  },
  {
    name: null,
    text: 'Apple App Store',
    descriptionText: 'Zum Download der Magenta SmartHome App für Apple iOS klicken Sie auf den nebenstehenden Button:',
    kind: null,
    url: 'https://apps.apple.com/de/app/magenta-smarthome/id698708574',
    resourcePath: null,
    isImportant: true,
    externalLink: true,
    ariaLabelText: '',
  },
  {
    name: null,
    text: 'Google Play',
    descriptionText: 'Zum Download der Magenta SmartHome App für Android klicken Sie auf den nebenstehenden Button:',
    kind: null,
    url: 'https://play.google.com/store/apps/details?id=de.telekom.smarthomeb2c&hl=de',
    resourcePath: null,
    isImportant: false,
    externalLink: true,
  },
];

export default [
  {
    description: 'Default',
  },
  {
    description: 'CAP-2015: All fields + multiple BundleInformation',
    texts: {
      minimumCommitmentPeriodTextMyProducts: 'minimumCommitmentPeriodTextMyProducts <strong>xyz</strong>',
    },
    productOptions: [
      newProductOption({
        subscriptionDescriptions: [
          {
            name: 'Lizenzschlüssel',
            text: '34340983298173329834982',
            descriptionText: null,
            kind: 'html',
          },
          {
            name: 'Raw test',
            text: 'Lorem <b>no html in raw mode!</b> ipsum',
            descriptionText: 'raw',
            kind: 'html',
          },
          {
            name: 'HTML test',
            text: 'Lorem <b>with html</b> ipsum, Lorem <b>with html</b> ipsum, Lorem <b>with html</b> ipsum',
            descriptionText: null,
            kind: 'html',
          },
          {
            name: 'Simple Text test',
            text: 'Lorem <b>no html</b> ipsum',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'descriptionText test',
            text: 'Lorem ipsum',
            descriptionText: '<b>HTML</b> description text',
            kind: 'text',
          },
          {
            name: 'Downloads: parameterNameMyProducts xyz',
            text: '<a title="Norton 360 für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDw4FBm1GXSSS6YRUPWB2F0VX4CUJCTUpv0Wv%2f%2bWdxSZRR%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">N360 für PC</a>  <a title="Norton AntiVirus für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDLEHha0FZ4YZVCU2QEZY1144P280AZT%2b%2b0%2f9%2f8JC58HJB%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">NAV für PC</a>  <a title="Norton Internet Security für PC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fDgf8KU0G8EXFS0II69MD51UDQ5VEAHnOBOPa%2fuKtb1GT0%3foverrideParameters%3d%2f%26%7e%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=11" target="_blank">NIS für PC</a>  <a title="Norton Internet Security für MAC" href="https://webdl.symantec.com/?SASSERVER=xsas.symantec.com&amp;TRANSID=%2f629236610%2fCAjeVg27EBX20103GBHQQ1NNPCL2B6I8%2bon%2b%2fPzAtLZBL%3foverrideParameters%3d%2f%26%7e%2f34340983298173329834982%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%2f%26%7e%26LNG%3dDEU&amp;LNG=DEU&amp;USEDM=1&amp;BINARYTYPE=17" target="_blank">NIS für MAC</a>  <a title="Norton Mobile Security für Android und iOS" href="https://cloudconnect.norton.com/Download?skup=21321914&amp;partnerUnitId=1307&amp;pin=34340983298173329834982" target="_blank">NMS für Android und iOS</a> parameterValueMyProducts <strong>xyz</strong>',
            descriptionText: null,
            kind: 'html',
          },
        ],
        nextRegularPayment: '03.05.2014',
        cancellationDate: '31.12.2018',
        chargingIntervalList: [
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '0,10€',
            intervalState: 2,
          },
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '999,99€',
            intervalState: 3,
          },
        ],
        additionalInformation: {
          subscriptionTemplateId: 'AUTO002',
          previousSubscription: {
            productName: 'Fahr Audi',
            subscriptionTemplateId: 'AUTO001',
            uniqueSubscriptionId: 'AUTO001-1',
          },
          followupSubscription: null,
          identifierType: 'FixedNetContractId',
          identifierValue: 'TR123456890',
        },
        bundleInformation: [
          {
            bundleTemplateId: 'B000001',
            setupDate: '24.05.2018 23:23:59',
            returnCode: '2',
            bundleType: '2',
            requestName: 'OMSOE_someStuff',
            requestResult: '1',
            provisioningTime: '24.05.2018 00:00:02',
          },
          {
            bundleTemplateId: 'B000002',
            setupDate: '12.01.2018 23:23:59',
            returnCode: '2',
            bundleType: '1',
            requestName: 'OMSOE_otherStuff',
            requestResult: '1',
            provisioningTime: '12.12.2018 00:00:03',
          },
        ],
      }),
    ],
  },
  {
    description: 'CAP-2015: with followupSubscription',
    productOptions: [
      newProductOption({
        nextRegularPayment: null,
        cancellationDate: '31.12.2018',
        chargingIntervalList: [
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '0,10€',
            intervalState: 99,
          },
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '999,99€',
          },
        ],
        additionalInformation: {
          subscriptionTemplateId: 'AUTO002',
          previousSubscription: null,
          followupSubscription: {
            productName: 'Fahr Audi',
            subscriptionTemplateId: 'AUTO001',
            uniqueSubscriptionId: 'AUTO001-1',
          },
          identifierType: 'FixedNetContractId',
          identifierValue: 'TR123456890',
        },
        bundleInformation: [
          {
            bundleTemplateId: 'B000001',
            setupDate: '24.05.2018 23:23:59',
            returnCode: '2',
            bundleType: '2',
            requestName: 'OMSOE_someStuff',
            requestResult: '1',
            provisioningTime: '24.05.2018 00:00:02',
          },
        ],
      }),
    ],
  },
  {
    description: 'CAP-2015: minimal Zahlungsinformationen',
    productOptions: [
      newProductOption({
        nextRegularPayment: '03.05.2014',
        additionalInformation: {
          subscriptionTemplateId: 'AUTO002',
          previousSubscription: null,
          followupSubscription: null,
          identifierType: null,
          identifierValue: null,
        },
        bundleInformation: [
          {
            bundleTemplateId: 'B000001',
            setupDate: '24.05.2018 12:12:50',
            returnCode: '2',
            bundleType: '1',
            requestName: 'OMSOE_someStuff',
            requestResult: '1',
            provisioningTime: '24.05.2018 00:00:02',
          },
        ],
      }),
    ],
  },
  {
    description: 'CAP-2015: empty additionalInformation',
    productOptions: [
      newProductOption({
        nextRegularPayment: '03.05.2014',
        cancellationDate: '31.12.2018',
        chargingIntervalList: [
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '0,10€',
          },
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '999,99€',
          },
        ],
        additionalInformation: null,
        bundleInformation: [
          {
            bundleTemplateId: 'B000001',
            setupDate: '24.05.2018 12:00:00',
            returnCode: '2',
            bundleType: '2',
            requestName: 'OMSOE_someStuff',
            requestResult: '1',
            provisioningTime: '24.05.2018 00:00:02',
          },
        ],
      }),
    ],
  },
  {
    description: 'CAP-2015: empty Zahlungsinformationen',
    productOptions: [
      newProductOption({
        additionalInformation: {
          subscriptionTemplateId: 'AUTO002',
          previousSubscription: {
            productName: 'Fahr Audi',
            subscriptionTemplateId: 'AUTO001',
            uniqueSubscriptionId: 'AUTO001-1',
          },
          followupSubscription: null,
          identifierType: 'FixedNetContractId',
          identifierValue: 'TR123456890',
        },
        bundleInformation: [
          {
            bundleTemplateId: 'B000001',
            setupDate: '24.05.2018 12:34:56',
            returnCode: '2',
            bundleType: '2',
            requestName: 'OMSOE_someStuff',
            requestResult: '1',
            provisioningTime: '24.05.2018 00:00:02',
          },
        ],
      }),
    ],
  },
  {
    description: 'OverrideTexts: all buttons + minimumCommitmentPeriodOverrideTextMyProducts',
    texts: {
      minimumCommitmentPeriodOverrideTextMyProducts: 'minimumCommitmentPeriod<b>Override</b>TextMyProducts <b>xyz</b>',
      orderCancellationButtonLabel: 'orderCancellationButtonLabel xyz',
      orderTerminationButtonLabel: 'orderTerminationButtonLabel xyz',
      orderReservationDeletionButtonLabel: 'orderReservationDeletionButtonLabel xyz',
      orderReactivationButtonLabel: 'orderReactivationButtonLabel xyz',
      productChangeButtonLabel: 'productChangeButtonLabel xyz',
      orderFinalisationButtonLabel: 'orderFinalisationButtonLabel xyz',
      orderReservationFinalisationButtonLabel: 'orderReservationFinalisationButtonLabel xyz',
      orderAdministrationButtonLabel: 'orderAdministrationButtonLabel xyz',
      orderOptinButtonLabel: 'orderOptinButtonLabel xyz',
      orderTerminationQuestion: 'orderTerminationQuestion <strong>xyz</strong>',
      orderReservationDeletionQuestion: 'orderReservationDeletionQuestion <strong>xyz</strong>',
      orderCancellationDateQuestion: 'orderCancellationDateQuestion <strong>xyz</strong>',
      orderCancellationQuestion: 'orderCancellationQuestion <strong>xyz</strong>',
      orderReactivationQuestion: 'orderReactivationQuestion <strong>xyz</strong>',
    },
    productOptions: [
      newProductOption({
        finalizeAllowed: true,
        resumeAllowed: true,
        terminationAllowed: true,
        reservationTerminationAllowed: true,
        reactivationAllowed: true,
        administrationAllowed: true,
        optinAllowed: true,
      }),
    ],
  },
  {
    description: 'no minimumCommitmentPeriodFactor',
    productOptions: [
      newProductOption({
        minimumCommitmentPeriodFactor: 0,
      }),
    ],
  },
  {
    description: 'subscriptionBookedByExtern = true (minimumCommitmentPeriod hidden)',
    productOptions: [
      newProductOption({
        subscriptionBookedByExtern: true,
      }),
    ],
  },
  {
    description: 'productOption status inactive',
    productOptions: [
      newProductOption({
        status: 'inactive',
      }),
    ],
  },
  {
    description: 'subscriptionEndDate set, promotionEndDate set',
    productOptions: [
      newProductOption({
        subscriptionEndDate: '03.05.2014',
        promotionEndDate: '13.05.2014',
      }),
    ],
  },
  {
    description: 'reservationTerminationAllowed + canNotSucceed',
    canNotSucceed: true,
    productOptions: [
      newProductOption({
        reservationTerminationAllowed: true,
      }),
    ],
  },
  {
    description: 'informationFields',
    productOptions: [
      newProductOption({
        informationFields: [
          {
            name: 'InformationFieldTest1',
            text: 'One two three',
            descriptionText: 'Lorem ipsum description text of first information field box.',
            kind: 'html',
            url: 'url123',
            resourcePath: 'images/139.jpg',
          },
          {
            name: 'InformationFieldTest1',
            text: 'One two three',
            descriptionText: 'Lorem ipsum description text of first information field box.',
            kind: 'html',
            url: 'url123',
            resourcePath: 'images/dummy_small.jpg',
          },
          {
            name: 'InformationFieldTest2',
            text: 'info field text2 <b>HTML</b> test',
            descriptionText: 'This is another information field box with a slightly longer example text lorem ipsum dolor lorem lorem ipsum <b>html</b> xyz.',
            kind: null,
            url: null,
            resourcePath: 'images/dummy_small.jpg',
          },
        ],
      }),
    ],
  },
  {
    description: 'informationFields real',
    productOptions: [merge({}, productOption, { informationFields })],
  },
  {
    description: 'informationFields on multiple productOptions',
    cntNotTerminated: 2,
    productOptions: [
      newProductOption({ informationFields }),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'locked',
        inPromotionPeriod: true,
        informationFields,
      }),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'reserved',
      }),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'inactive',
        informationFields: [
          {
            name: 'InformationFieldTest1',
            text: 'One two three',
            descriptionText: 'MAY NOT BE VISIBLE ON INACTIVE OPTIONS!',
            kind: 'html',
            url: 'url123',
          },
          {
            name: 'InformationFieldTest2',
            text: 'One two three',
            descriptionText: 'MAY NOT BE VISIBLE ON INACTIVE OPTIONS!',
            kind: 'html',
            url: 'url123',
            isImportant: true,
          },
        ],
      }),
      newProductOption({
        isFirstNotTerminated: false,
        subscriptionEndDate: '03.05.2014',
        informationFields: [
          {
            name: 'InformationFieldTest1',
            text: 'One two three',
            descriptionText: 'Just another single line important information field',
            kind: 'html',
            url: 'url123',
            isImportant: true,
          },
        ],
      }),
      newProductOption({
        isFirstNotTerminated: false,
        promotionEndDate: '03.05.2014',
        informationFields: [
          {
            name: 'InformationFieldTest1',
            text: 'One two three',
            descriptionText: 'Just another single line NOT important information field',
            kind: 'html',
            url: 'url123',
            isImportant: false,
          },
        ],
      }),
      newProductOption({
        isFirstNotTerminated: false,
        subscriptionEndDate: '03.05.2014',
        promotionEndDate: '03.05.2014',
        informationFields,
      }),
    ],
  },
  {
    description: 'chargingIntervalList + nextRegularPayment + canNotSucceed + reservationTerminationAllowed',
    canNotSucceed: true,
    productOptions: [
      newProductOption({
        reservationTerminationAllowed: true,
        nextRegularPayment: '03.05.2014',
        chargingIntervalList: [
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '0,10€',
          },
          {
            intervalDurationStart: '03.05.2014',
            intervalDurationEnd: '03.05.2014',
            priceDisplay: '999,99€',
          },
        ],
      }),
    ],
  },
  {
    description: 'multiple productOptions, different status',
    cntNotTerminated: 2,
    texts: {
      // ongoingPromotionInfo: 'ongoingPromotionInfo <b>xyz</b>',
    },
    productOptions: [
      newProductOption(),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'locked',
      }),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'reserved',
        inPromotionPeriod: true,
      }),
      newProductOption({
        isFirstNotTerminated: false,
        status: 'inactive',
      }),
      newProductOption({
        isFirstNotTerminated: false,
        subscriptionEndDate: '03.05.2014',
      }),
      newProductOption({
        isFirstNotTerminated: false,
        promotionEndDate: '03.05.2014',
      }),
      newProductOption({
        isFirstNotTerminated: false,
        subscriptionEndDate: '03.05.2014',
        promotionEndDate: '03.05.2014',
      }),
    ],
  },
  {
    description: 'cancelAllowed = false, productChangeAllowed = false, rest allowed',
    productOptions: [
      newProductOption({
        cancelAllowed: false,
        productChangeAllowed: false,
        finalizeAllowed: true,
        resumeAllowed: true,
        terminationAllowed: true,
        reservationTerminationAllowed: true,
        reactivationAllowed: true,
        administrationAllowed: true,
        optinAllowed: true,
      }),
    ],
  },
  {
    description: 'ongoing promotion info with custom text + optinPossibleLongInfo',
    texts: {
      ongoingPromotionInfo: 'ongoingPromotionInfo text <b>html?</b>',
      optinPossibleLongInfo: 'optinPossibleLongInfo text <b>html?</b>',
    },
    productOptions: [
      newProductOption({
        inPromotionPeriod: true,
        optinPossible: true,
      }),
    ],
  },
  {
    description: 'ongoing promotion info with default text',
    productOptions: [
      newProductOption({
        inPromotionPeriod: true,
      }),
    ],
  },
  {
    description: 'ongoing promotion info with short text',
    texts: {
      optinPossibleShortInfo: 'optinPossibleShortInfo <b>html?</b>',
    },
    productOptions: [
      newProductOption({
        inPromotionPeriod: true,
        optinPossible: true,
      }),
    ],
  },
  {
    description: 'With Details button',
    productOptions: [
      newProductOption({
        chargingIntervalList: [
          {
            intervalDurationStart: '01.11.2018',
            intervalDurationEnd: '30.11.2018',
            priceDisplay: '1,00 €',
            intervalState: 2,
            paymentTransactionList: [
              {
                terminationReason: 0,
                timestamp: '2019-09-09',
                transactionId: 1853380803,
              },
              {
                terminationReason: 0,
                timestamp: '2019-09-04',
                transactionId: 4000,
              },
              {
                terminationReason: 0,
                timestamp: '2019-09-03',
                transactionId: 3000,
              },
              {
                terminationReason: 1,
                timestamp: '2019-09-02',
                transactionId: 2000,
              },
            ],
          },
          {
            intervalDurationStart: '01.11.2018',
            intervalDurationEnd: '30.11.2018',
            priceDisplay: '1,00 €',
            intervalState: 4,
            paymentTransactionList: [
              {
                terminationReason: 0,
                timestamp: '2019-09-09',
                transactionId: 1853380803,
              },
              {
                terminationReason: 0,
                timestamp: '2019-09-04',
                transactionId: 4000,
              },
              {
                terminationReason: 0,
                timestamp: '2019-09-03',
                transactionId: 3000,
              },
              {
                terminationReason: 1,
                timestamp: '2019-09-02',
                transactionId: 2000,
              },
            ],
          },
        ],
      }),
    ],
  },
  {
    description: 'With dates',
    productOptions: [
      newProductOption({
        uniqueSubscriptionId: 'usid-dates',
        subscriptionDescriptions: [
          {
            name: 'Date1',
            text: '2020-02-01T12:59:59Z',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date2',
            text: '2020-02-01T12:59:59+01:00',
            descriptionText: 'raw',
            kind: 'text',
          },
          {
            name: 'Date3',
            text: '2008-02-01T09:00:22+05',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date4',
            text: '2020-02-01T12:59:59',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date5',
            text: '2020-02-01',
            descriptionText: 'Only date part',
            kind: 'text',
          },
          {
            name: 'Date6',
            text: '2020-02-01 12:59:59',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date7',
            text: '2020-02-01T12:59:59_CET',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date8',
            text: '2010-11-22 08:08:08.123456',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Date9',
            text: '2020-03-13T09:31:04.734+06:00',
            descriptionText: null,
            kind: 'text',
          },
          {
            name: 'Normal text',
            text: '1234567 hello world',
            descriptionText: null,
            kind: 'text',
          },
        ],
      }),
    ],
  },
  {
    description: 'orderCancellationAbortButtonLabelImportant',
    texts: {
      orderCancellationConfirmButtonLabel: 'Confirm ButtonLabel override',
      orderCancellationAbortButtonLabel: 'Abort ButtonLabel override',
    },
    orderCancellationAbortButtonLabelImportant: true,
    productOptions: [
      newProductOption({
        terminationAllowed: true,
      }),
    ],
  },
  {
    description: 'button override',
    texts: {
      orderCancellationConfirmButtonLabel: 'Confirm ButtonLabel override',
      orderCancellationAbortButtonLabel: 'Abort ButtonLabel override',
    },
    productOptions: [
      newProductOption({
        terminationAllowed: true,
      }),
    ],
  },
  {
    description: 'button override + only one orderCancellationAbortButtonLabelImportant',
    texts: {
      orderCancellationAbortButtonLabel: 'Abort ButtonLabel override',
    },
    orderCancellationAbortButtonLabelImportant: true,
    productOptions: [
      newProductOption({
        terminationAllowed: true,
      }),
    ],
  },
  {
    description: 'planned cancel allowed',
    productOptions: [
      newProductOption({
        plannedCancelAllowed: true,
      }),
    ],
  },
  {
    description: 'TSPC-2347: resend documents - single option',
    productOptions: [
      newProductOption({
        resendDocumentAllowed: true,
        uniqueSubscriptionId: '00MGEKL-3',
      }),
    ],
  },
  {
    description: 'TSPC-2347: resend documents - multi option - first',
    productOptions: [
      newProductOption({
        resendDocumentAllowed: true,
        uniqueSubscriptionId: '00MGEKL-3',
      }),
      newProductOption(),
    ],
  },
  {
    description: 'TSPC-2347: resend documents - multi option - last',
    productOptions: [
      newProductOption(),
      newProductOption({
        resendDocumentAllowed: true,
        uniqueSubscriptionId: '00MGEKL-3',
      }),
    ],
  },
  {
    description: 'disney+',
    texts: {
      orderCancellationConfirmButtonLabel: 'Ja, ich möchte Disney+ kündigen',
      orderCancellationAbortButtonLabel: ' Nein, ich möchte Disney+ behalten',
      orderCancellationQuestion:
        '<h2>Möchten Sie darauf wirklich verzichten?</h2>\n<div id="hiddenFootnote" style="display: none;"><sup>1</sup></div>\n<br /> <img src="delegates/product/content/images/379.jpg" alt="" width="100%" height="100%" /> <br /><br />',
    },
    orderCancellationAbortButtonLabelImportant: true,
    productOptions: [
      newProductOption({
        terminationAllowed: true,
      }),
    ],
  },
  {
    description: 'disney+ with plannedCancelAllowed',
    texts: {
      orderCancellationConfirmButtonLabel: 'Ja, ich möchte Disney+ kündigen',
      orderCancellationAbortButtonLabel: ' Nein, ich möchte Disney+ behalten',
      orderCancellationQuestion:
        '<h2>Möchten Sie darauf wirklich verzichten?</h2>\n<div id="hiddenFootnote" style="display: none;"><sup>1</sup></div>\n<br /> <img src="delegates/product/content/images/379.jpg" alt="" width="100%" height="100%" /> <br /><br />',
    },
    orderCancellationAbortButtonLabelImportant: true,
    productOptions: [
      newProductOption({
        terminationAllowed: true,
        plannedCancelAllowed: true,
      }),
    ],
  },
];
